export default ({ app }, inject) => {
  inject('isHtml', (str) => {
    if (!str) return null

    return /<[a-z][\s\S]*>/i.test(str)
  })
}
